// ============================================
// Creator State - Intro Blocks (Zustand 기반)
// ============================================

import { useCreatorStore, INTRO_IMAGE_PAGE_SIZE as _INTRO_IMAGE_PAGE_SIZE } from '../../../stores/creatorStore.js';

export const INTRO_IMAGE_PAGE_SIZE = _INTRO_IMAGE_PAGE_SIZE;

// ============================================
// 인트로 블록 상태
// ============================================

export const getIntroBlocks = () => useCreatorStore.getState().introBlocks;
export const getCurrentIntroType = () => useCreatorStore.getState().currentIntroType;
export const getSelectedIntroBlockIndex = () => useCreatorStore.getState().selectedIntroBlockIndex;

export function setIntroBlocks(blocks) {
  useCreatorStore.getState().setIntroBlocks(blocks);
}

export function setCurrentIntroType(type) {
  useCreatorStore.getState().setCurrentIntroType(type);
}

export function setSelectedIntroBlockIndex(index) {
  useCreatorStore.getState().setSelectedIntroBlockIndex(index);
}

// ============================================
// 인트로 이미지 선택 페이지네이션
// ============================================

export const getIntroImagePage = () => useCreatorStore.getState().introImagePage;
export const getIntroImageLoading = () => useCreatorStore.getState().introImageLoading;
export const getIntroImageHasMore = () => useCreatorStore.getState().introImageHasMore;
export const getIntroImageMode = () => useCreatorStore.getState().introImageMode;
export const getEditingIntroImageIndex = () => useCreatorStore.getState().editingIntroImageIndex;

export function setIntroImagePage(page) {
  useCreatorStore.getState().setIntroImagePage(page);
}

export function setIntroImageLoading(loading) {
  useCreatorStore.getState().setIntroImageLoading(loading);
}

export function setIntroImageHasMore(hasMore) {
  useCreatorStore.getState().setIntroImageHasMore(hasMore);
}

export function setIntroImageMode(mode) {
  useCreatorStore.getState().setIntroImageMode(mode);
}

export function setEditingIntroImageIndex(index) {
  useCreatorStore.getState().setEditingIntroImageIndex(index);
}
